import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { VehiculeInfosManagement } from '../components/VehiculeInfosManagement';
import { useNavigate } from 'react-router-dom';
import {
  TVehiculeSchema,
  vehiculeSchema,
} from '@/schemas/vehicule/vehicule.schema';
import { useCreateVehicule } from '@/hooks/vehicule.hooks';
import { useTranslation } from 'react-i18next';
import { VehiculeOwnerType } from '@/api/entities/vehicule';
import { Loader } from '@/components/Loading/Loader';

export const CreateVehiculePage = () => {
  const { t } = useTranslation('vehicule');
  const navigate = useNavigate();

  const {
    watch: watchVehicule,
    control: vehiculeControl,
    register: registerVehicule,
    setValue: setVehiculeValue,
    setError: setVehiculeError,
    handleSubmit: handleSubmitVehicule,
    formState: { errors: vehiculeErrors, isSubmitting: isSubmittingVehicule },
  } = useForm<TVehiculeSchema>({
    resolver: zodResolver(vehiculeSchema),
  });

  const { mutate: mutateCreateVehicule, isPending: isPendingCreateVehicule } =
    useCreateVehicule({
      t,
      handleSuccess: () => navigate('/vehicules'),
    });

  const onSubmitVehicule = (vehicule: TVehiculeSchema) => {
    const { ownerType, ownerGroupId, ownerCompanyId } = vehicule;

    if (
      (ownerType == VehiculeOwnerType.GROUP && !ownerGroupId) ||
      (ownerType == VehiculeOwnerType.COMPANY && !ownerCompanyId)
    ) {
      vehicule = {
        ...vehicule,
        ownerType: null,
        ownerGroupId: ownerGroupId || null,
        ownerCompanyId: ownerCompanyId || null,
      };
    }

    delete vehicule?.isToAdd;

    mutateCreateVehicule(vehicule);
  };

  return (
    <>
      <PageHeader
        backToLink="/vehicules"
        title={t('common:vehicule')}
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem text={t('vehiculeList')} linkTo="/vehicules" />
            <BreadcrumbItem text={t('common:vehicule')} active />
          </BreadcrumbList>
        }
      />
      <div className="flex flex-col gap-12">
        <VehiculeInfosManagement<TVehiculeSchema>
          t={t}
          watch={watchVehicule}
          control={vehiculeControl}
          register={registerVehicule}
          setValue={setVehiculeValue}
          setError={setVehiculeError}
          errors={vehiculeErrors}
          submitDisabled={isSubmittingVehicule || isPendingCreateVehicule}
          onSubmit={handleSubmitVehicule(onSubmitVehicule)}
        />
      </div>
      {(isSubmittingVehicule || isPendingCreateVehicule) && <Loader />}
    </>
  );
};
